/**
 * Bayenah V3 — bilingual terminology helpers.
 *
 * `TERMS` returns the Arabic strings (legacy callers expect this shape).
 * `T(language)` returns the same keys resolved for the active language —
 *   ```
 *   const t = T(language);   // language === 'ar' | 'en'
 *   t.vault                  // → 'الخزانة القانونية' or 'Legal Vault'
 *   ```
 * Centralised so labels stay consistent and easy to update in one place.
 */

const AR = {
  // Brand
  brand:        'بيّنة',
  brandName:    'بيّنة',
  tagline:      'مستشارك القانوني الذكي',
  brandTagline: 'مستشارك القانوني الذكي',

  // Navigation
  assistant:    'المستشار الذكي',
  vault:        'قاعدة المعرفة',
  multiAgent:   'الوكلاء المتخصصون',
  agent:        'الوكيل الذكي',
  agents:       'الوكلاء الذكيون',
  workflow:     'مسار العمل',
  workflows:    'مسارات العمل',
  draftLibrary: 'المكتبة',
  templates:    'النماذج القانونية',
  guidance:     'الدليل القانوني',
  settings:     'الإعدادات',
  trust:        'الثقة والأمان',
  blog:         'المدونة القانونية',

  // Section labels
  main:                'الرئيسية',
  home:                'الرئيسية',
  discover:            'الاكتشاف',
  recentChats:         'المحادثات الأخيرة',
  recentConversations: 'المحادثات الأخيرة',

  // Actions
  newChat:    '+ محادثة جديدة',
  upload:     'رفع',
  download:   'تحميل',
  analysis:   'تحليل',
  review:     'مراجعة',
  draft:      'صياغة',
  compliance: 'امتثال',
  save:       'حفظ التغييرات',
  retry:      'إعادة المحاولة',

  // Status
  pending:   'معلق',
  running:   'جاري',
  failed:    'فشل',
  paused:    'متوقف',
  completed: 'مكتمل',

  // Roles
  owner:  'مالك',
  admin:  'مشرف',
  member: 'عضو',
  reader: 'قارئ',

  // Auth
  signIn:         'تسجيل الدخول',
  signUp:         'إنشاء حساب',
  signOut:        'تسجيل الخروج',
  forgotPassword: 'نسيت كلمة المرور؟',

  // Empty states
  noDocuments: 'لا توجد مستندات في الخزانة بعد',
  noDrafts:    'لا توجد مسودات بعد',
  noRuns:      'لا توجد تشغيلات بعد',
  noActivity:  'لا يوجد نشاط بعد',

  // Disclaimer
  disclaimer: 'للاطلاع فقط — لا تُعد استشارة قانونية رسمية',
};

const EN = {
  brand:        'Bayenah',
  brandName:    'Bayenah',
  tagline:      'Your AI legal advisor',
  brandTagline: 'Your AI legal advisor',

  assistant:    'Smart Assistant',
  vault:        'Knowledge Base',
  multiAgent:   'Specialised Agents',
  agent:        'Agent',
  agents:       'Agents',
  workflow:     'Workflow',
  workflows:    'Workflows',
  draftLibrary: 'Library',
  templates:    'Legal Templates',
  guidance:     'Legal Guidance',
  settings:     'Settings',
  trust:        'Trust & Security',
  blog:         'Legal Blog',

  main:                'Main',
  home:                'Main',
  discover:            'Discover',
  recentChats:         'Recent Chats',
  recentConversations: 'Recent Chats',

  newChat:    '+ New Chat',
  upload:     'Upload',
  download:   'Download',
  analysis:   'Analyse',
  review:     'Review',
  draft:      'Draft',
  compliance: 'Compliance',
  save:       'Save changes',
  retry:      'Retry',

  pending:   'Pending',
  running:   'Running',
  failed:    'Failed',
  paused:    'Paused',
  completed: 'Completed',

  owner:  'Owner',
  admin:  'Admin',
  member: 'Member',
  reader: 'Reader',

  signIn:         'Sign in',
  signUp:         'Sign up',
  signOut:        'Sign out',
  forgotPassword: 'Forgot password?',

  noDocuments: 'No documents in your vault yet',
  noDrafts:    'No drafts yet',
  noRuns:      'No runs yet',
  noActivity:  'No activity yet',

  disclaimer: 'For reference only — not formal legal advice',
};

export const TERMS = AR;            // legacy alias — Arabic copy.
export const TERMS_AR = AR;
export const TERMS_EN = EN;

/**
 * `T(language)` → resolves to AR or EN map.
 * Defaults to Arabic when language is missing or unknown.
 */
export function T(language) {
  return language === 'en' ? EN : AR;
}

export default TERMS;
